import {
    FETCH_CATEGORY_TREE_FULFILLED,
    SELECTED_CATEGORY,
    FILTER_CAT_TREE
} from '../actions/CategoryCreators';

export const CategoryReducer = (state = {
    categoryTree: null,
    selectedCategories: null
}, action) => {
    switch (action.type) {
        case FETCH_CATEGORY_TREE_FULFILLED:
            return {
                ...state,
                categoryTree: action.payload
            }
        case SELECTED_CATEGORY:
            return {
                ...state,
                selectedCategories: action.payload
            }
        case FILTER_CAT_TREE:
            return {
                ...state,
                categoryTree: action.payload
            }
        default:
    }
    return state;
}